<template>
  <div >
    <div>
       <UnavailableMenu />
    </div>
  <!--
		<div class="modal-header tag-partner">
			<img src="https://api.quomi.it/oldimg/Quomi-logo-trasparente.png" alt="logo">
			<h2 class="text-center mt-3">Benvenuto su Quomi!</h2>
		</div>

		<div class='header-legend tag-partner' :class="{'center my-3' : emailLogin}">
			<span>{{ $t("auth.signin.providers") }}</span>
		</div>

		<div class="flex justify-content-around">
			<v-btn
				outlined
				class=" google-btn tag-partner"
				@click="login('google')"
			>
				<i class="fab fa-google fa-1.5x"></i>
				<span class="text-bold capitalize ml-1" style="color: #4285F4">Google</span>
			</v-btn>

			<CTA
				:content="'Facebook'"
				:size="`small`"
				:color="`blue`"
				@click="login('facebook')"
				class="facebook-btn tag-partner"
			/>
		</div>


		<div v-if="$root.source == 'bennet'">

			<div class="modal-header">
				<img src="https://api.quomi.it/oldimg/logo-instacook.webp" alt="logo">
				<h2 class="text-center mt-3 mb-5">Benvenuto su Instacook!</h2>
			</div>


			<CTA
				:content="`Accedi o Registrati`"
				:size="`small`"
				:color="`green`"
				@click="login('bennet')"
			/>
		</div>


		<div class='header-legend tag-partner' :class="{'center my-3' : emailLogin}">
			<span>{{ $t("auth.signin.divider") }}</span>
		</div>

		<form class='form' method="POST" @submit.prevent="login()" id="login">
			<div>
				<input name="email" type='text' class='form-control' v-model="form.username" :placeholder='$t("auth.signin.username")' required pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$">
			</div>

			<div>
				<input-password
					v-model="form.password"
				/>
			</div>

			<flash
				:flash="errorStore.message"
				:state="state"
			/>

			<p class="text-right">

			<router-link :to="{ name: 'recovery' }" class="link-detail" title="">
				{{ $t("auth.signin.forgot_password.url") }}
			</router-link>

			</p>

			<CTA
				isWithLoader
				:loading="loading"
				:content="`Accedi`"
				:isArrow="loading ? false : true"
				:size="`small`"
			/>
		</form>
		<div class="flex justify-content-center mt-5 tag-partner" v-show="!emailLogin">
			<small>Non hai un account?</small>
			<small>
				<a class="sign-up-link pl-2 text-bold" @click="openSignUp">Registrati</a>
			</small>
		</div>
-->
	</div>
</template>

<script>

import { container } from '../services/container'

import InputPassword from './Parts/InputPassword'
import UnavailableMenu from '@/components/Checkout/UnavailableMenu'
import { errorStore } from '../store/errorStore'
import Flash from './Parts/Flash'
export default {
	name: 'SignIn',

	data () {
		return {
			form: {},
			state: 'error',
			loading: false,
			errorStore: errorStore.state
		}
	},

	props: {
		emailLogin: {
			type: Boolean,
			default: false
		}
	},

	components: {
		InputPassword,
    UnavailableMenu,
		Flash
	},

	methods: {
		open () {
			this.$refs.modal.open()
			this.$emit('update:activeModal', 'signin')
		},

		openSignUp () {
			this.close()
			this.openModal('signup')
			/* setTimeout(() =>{
				this.$refs.modal.open()
				this.$emit('update:activeModal', 'signup')
			},500) */
		},

		openModal (target) {
			this.$emit('openModal', target)
		},

		close () {
			this.$emit("update:activeModal", null);
      this.$emit("close", null);
		},

		login (provider) {
			if (provider) {
				if(this.emailLogin === true) {
					this.$emit('login-mail', provider)
					return
				}
				container
					.get('services.oauth')
					.providerSignIn(provider, {})
			} else {
				this.loading = true
				errorStore.removeMessage()
				container
					.get('services.oauth')
					.signIn(this.form)

				.then(response => {
					window.location.reload()
					this.loading = false
				})

				.catch(response => {
					this.loading = false
					errorStore.formatMessage(response)
				})
			}
		}
	}
}
</script>

<style scoped>
	.link-detail {
		font-weight: normal;
	}

	.btn {
		width: 100%;
		border: none;
	}

	.modal-header {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0;
		border: none;
	}

	.modal-header img {
		width: 30%;
	}

	.sign-up-link {
		color: var(--quomi-blue);
	}

	.sign-up-link:hover {
		color: var(--quomi-blue-hover);
		cursor: pointer;
	}

	.facebook-btn {
		width: 45%;
		display: inline-block;
		color: white;
	}

	.google-btn {
		width: 45%;
		display: inline-block;
		border: 1px solid #4285F4;
	}

	.fa-google {
  background: conic-gradient(from -45deg, #ea4335 110deg, #4285f4 90deg 180deg, #34a853 180deg 270deg, #fbbc05 270deg) 73% 55%/150% 150% no-repeat;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
	}

</style>
